@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-dropdown'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="invalid()">
    </form-label>
}

@if (!multiple()) {
    <p-select
        [inputId]="id() + '-dropdown'"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [options]="options()"
        [(ngModel)]="value"
        [showClear]="showClear()"
        [filter]="filter()"
        [filterBy]="filterBy() || optionLabel()"
        [fluid]="fluid()"
        [disabled]="disabled()"
        [placeholder]="placeholder() | translate"
        [emptyMessage]="emptyMessage() | translate"
        [size]="size()"
        [invalid]="invalid()"
        [appendTo]="appendTo()"
        (onChange)="value.set(value())"
        (onClear)="onClear.emit()"
        (onHide)="onHide.emit()"
        (onFocus)="onFocus.emit()">
    </p-select>
} @else {
    <p-multiSelect
        [inputId]="id() + '-dropdown'"
        [display]="'chip'"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [optionDisabled]="optionDisabled()"
        [appendTo]="appendTo()"
        [showClear]="showClear()"
        [placeholder]="placeholder() | translate"
        [size]="size()"
        [options]="options()"
        [(ngModel)]="value"
        [fluid]="true"
        [filter]="filter()"
        [filterBy]="filterBy() || optionLabel()"
        [maxSelectedLabels]="10"
        [disabled]="disabled()"
        (onChange)="value.set(value())"
        (onClear)="onClear.emit()"
        (onPanelHide)="onHide.emit()"
        (onFocus)="onFocus.emit()">
    </p-multiSelect>
}
